import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _addDataCollectionPluginRequest = {};
var _addDataCollectionPluginResponse = { dataCollection: '_dataCollection' };
var _array = { typeMetadata: '_typeMetadata' };
var _bulkGetDataCollectionsRequest = {};
var _bulkGetDataCollectionsResponse = {
    activeCollections: '_dataCollection',
    deletedCollections: '_dataCollection',
};
var _createDataCollectionFieldRequest = { field: '_field' };
var _createDataCollectionFieldResponse = {
    dataCollection: '_dataCollection',
};
var _createDataCollectionRequest = { collection: '_dataCollection' };
var _createDataCollectionResponse = { collection: '_dataCollection' };
var _dataCollection = {
    createdDate: 'google.protobuf.Timestamp',
    updatedDate: 'google.protobuf.Timestamp',
    fields: '_field',
};
var _deleteDataCollectionFieldRequest = {};
var _deleteDataCollectionFieldResponse = {
    dataCollection: '_dataCollection',
};
var _deleteDataCollectionPluginRequest = {};
var _deleteDataCollectionPluginResponse = {
    dataCollection: '_dataCollection',
};
var _deleteDataCollectionRequest = {};
var _deleteDataCollectionResponse = {};
var _field = { numberRange: '_numberRange', typeMetadata: '_typeMetadata' };
var _getDataCollectionRequest = {};
var _getDataCollectionResponse = {
    collection: '_dataCollection',
    referencedCollections: '_dataCollection',
};
var _listDataCollectionsRequest = {};
var _listDataCollectionsResponse = { collections: '_dataCollection' };
var _numberRange = {
    min: 'google.protobuf.DoubleValue',
    max: 'google.protobuf.DoubleValue',
};
var _object = { fields: '_objectField' };
var _objectField = { typeMetadata: '_typeMetadata' };
var _patchDataCollectionFieldRequest = {
    fieldMask: 'google.protobuf.FieldMask',
    field: '_field',
};
var _patchDataCollectionFieldResponse = { dataCollection: '_dataCollection' };
var _patchDataCollectionRequest = {
    fieldMask: 'google.protobuf.FieldMask',
    dataCollection: '_dataCollection',
};
var _patchDataCollectionResponse = { dataCollection: '_dataCollection' };
var _restoreDataCollectionRequest = {};
var _restoreDataCollectionResponse = { dataCollection: '_dataCollection' };
var _typeMetadata = { object: '_object', array: '_array' };
var _updateDataCollectionFieldRequest = { field: '_field' };
var _updateDataCollectionFieldResponse = {
    dataCollection: '_dataCollection',
};
var _updateDataCollectionRequest = { collection: '_dataCollection' };
var _updateDataCollectionResponse = { collection: '_dataCollection' };
function resolveComWixpressCloudDataApiCollectionserviceDataCollectionServiceUrl(opts) {
    var domainToMappings = {
        'api._api_base_domain_': [
            {
                srcPath: '/cloud-data',
                destPath: '',
            },
        ],
        'code._base_domain_': [
            {
                srcPath: '/_api/cloud-data/v1/data-settings',
                destPath: '/v1/data-settings',
            },
            {
                srcPath: '/_api/cloud-data/v1/schemas',
                destPath: '/v1/schemas',
            },
            {
                srcPath: '/_api/cloud-data/v1/connector',
                destPath: '/v1/connector',
            },
            {
                srcPath: '/_api/data/v1/data-settings',
                destPath: '/v1/data-settings',
            },
            {
                srcPath: '/_api/data/v1/schemas',
                destPath: '/v1/schemas',
            },
            {
                srcPath: '/_api/data/v1/connector',
                destPath: '/v1/connector',
            },
            {
                srcPath: '/_api/cloud-data/v1/wix-data',
                destPath: '/v1/wix-data',
            },
        ],
        'cloud-data.wix-code.com': [
            {
                srcPath: '',
                destPath: '',
            },
        ],
        _: [
            {
                srcPath: '/_api/cloud-data',
                destPath: '',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/cloud-data',
                destPath: '',
            },
            {
                srcPath: '/_api/data',
                destPath: '',
            },
            {
                srcPath: '/_api/cloud-data',
                destPath: '',
            },
        ],
        'dev._base_domain_': [
            {
                srcPath: '/_api/cloud-data',
                destPath: '',
            },
        ],
        'bo._base_domain_': [
            {
                srcPath: '/_api/cloud-data/v1',
                destPath: '/v1',
            },
            {
                srcPath: '/_api/cloud-data/v2',
                destPath: '/v2',
            },
        ],
        'wixbo.ai': [
            {
                srcPath: '/_api/cloud-data/v1',
                destPath: '/v1',
            },
            {
                srcPath: '/_api/cloud-data/v2',
                destPath: '/v2',
            },
        ],
        'wix-bo.com': [
            {
                srcPath: '/_api/cloud-data/v1',
                destPath: '/v1',
            },
            {
                srcPath: '/_api/cloud-data/v2',
                destPath: '/v2',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/cloud-data',
                destPath: '',
            },
            {
                srcPath: '/_api/data',
                destPath: '',
            },
            {
                srcPath: '/_api/cloud-data',
                destPath: '',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/cloud-data/v1/schemas',
                destPath: '/v1/schemas',
            },
            {
                srcPath: '/_api/cloud-data/dbs/tasks',
                destPath: '/dbs/tasks',
            },
            {
                srcPath: '/_api/data/v1/schemas',
                destPath: '/v1/schemas',
            },
            {
                srcPath: '/_api/data/dbs/tasks',
                destPath: '/dbs/tasks',
            },
            {
                srcPath: '/_api/cloud-data/v1/wix-data',
                destPath: '/v1/wix-data',
            },
            {
                srcPath: '/_api/cloud-data/v1/data-settings',
                destPath: '/v1/data-settings',
            },
            {
                srcPath: '/_api/data/v2/indexes',
                destPath: '/v2/indexes',
            },
            {
                srcPath: '/_api/cloud-data/v1/external-database-connections',
                destPath: '/v1/external-database-connections',
            },
            {
                srcPath: '/_api/data/v1/data-collection-sharing',
                destPath: '/v1/data-collection-sharing',
            },
            {
                srcPath: '/_api/cloud-data/v2/collections',
                destPath: '/v2/collections',
            },
            {
                srcPath: '/_api/cloud-data/v2/bulk',
                destPath: '/v2/bulk',
            },
            {
                srcPath: '/_api/cloud-data/v2/items',
                destPath: '/v2/items',
            },
            {
                srcPath: '/_api/cloud-data/v2/dbs/tasks',
                destPath: '/v2/dbs/tasks',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/cloud-data/v1/schemas',
                destPath: '/v1/schemas',
            },
            {
                srcPath: '/_api/cloud-data/dbs/tasks',
                destPath: '/dbs/tasks',
            },
            {
                srcPath: '/_api/data/v1/schemas',
                destPath: '/v1/schemas',
            },
            {
                srcPath: '/_api/data/dbs/tasks',
                destPath: '/dbs/tasks',
            },
            {
                srcPath: '/_api/cloud-data/v1/wix-data',
                destPath: '/v1/wix-data',
            },
            {
                srcPath: '/_api/cloud-data/v1/data-settings',
                destPath: '/v1/data-settings',
            },
            {
                srcPath: '/_api/data/v2/indexes',
                destPath: '/v2/indexes',
            },
            {
                srcPath: '/_api/cloud-data/v1/external-database-connections',
                destPath: '/v1/external-database-connections',
            },
            {
                srcPath: '/_api/data/v1/data-collection-sharing',
                destPath: '/v1/data-collection-sharing',
            },
            {
                srcPath: '/_api/cloud-data/v2/collections',
                destPath: '/v2/collections',
            },
            {
                srcPath: '/_api/cloud-data/v2/bulk',
                destPath: '/v2/bulk',
            },
            {
                srcPath: '/_api/cloud-data/v2/items',
                destPath: '/v2/items',
            },
            {
                srcPath: '/_api/cloud-data/v2/dbs/tasks',
                destPath: '/v2/dbs/tasks',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/cloud-data/v1/schemas',
                destPath: '/v1/schemas',
            },
            {
                srcPath: '/_api/cloud-data/dbs/tasks',
                destPath: '/dbs/tasks',
            },
            {
                srcPath: '/_api/data/v1/schemas',
                destPath: '/v1/schemas',
            },
            {
                srcPath: '/_api/data/dbs/tasks',
                destPath: '/dbs/tasks',
            },
            {
                srcPath: '/_api/cloud-data/v1/wix-data',
                destPath: '/v1/wix-data',
            },
            {
                srcPath: '/_api/cloud-data/v1/data-settings',
                destPath: '/v1/data-settings',
            },
            {
                srcPath: '/_api/data/v2/indexes',
                destPath: '/v2/indexes',
            },
            {
                srcPath: '/_api/cloud-data/v1/external-database-connections',
                destPath: '/v1/external-database-connections',
            },
            {
                srcPath: '/_api/data/v1/data-collection-sharing',
                destPath: '/v1/data-collection-sharing',
            },
            {
                srcPath: '/_api/cloud-data/v2/collections',
                destPath: '/v2/collections',
            },
            {
                srcPath: '/_api/cloud-data/v2/bulk',
                destPath: '/v2/bulk',
            },
            {
                srcPath: '/_api/cloud-data/v2/items',
                destPath: '/v2/items',
            },
            {
                srcPath: '/_api/cloud-data/v2/dbs/tasks',
                destPath: '/v2/dbs/tasks',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/wix-data/v1/collections',
                destPath: '/v1/wix-data/collections',
            },
            {
                srcPath: '/wix-data/v1/external-database-connections',
                destPath: '/v1/external-database-connections',
            },
            {
                srcPath: '/wix-data/v2/indexes',
                destPath: '/v2/indexes',
            },
            {
                srcPath: '/wix-data/v1/items',
                destPath: '/v1/items',
            },
            {
                srcPath: '/wix-data/v1/bulk',
                destPath: '/v1/bulk',
            },
            {
                srcPath: '/wix-data/v1/external-databases',
                destPath: '/v1/external-databases',
            },
            {
                srcPath: '/wix-data/v2',
                destPath: '/v2',
            },
            {
                srcPath: '/data/v2/collections',
                destPath: '/v2/collections',
            },
            {
                srcPath: '/data/v2/items',
                destPath: '/v2/items',
            },
            {
                srcPath: '/data/v2/bulk/items',
                destPath: '/v2/bulk/items',
            },
            {
                srcPath: '/data/v2/indexes',
                destPath: '/v2/indexes',
            },
            {
                srcPath: '/data/v1/external-database-connections',
                destPath: '/v1/external-database-connections',
            },
            {
                srcPath: '/data/v1/data-collection-sharing',
                destPath: '/v1/data-collection-sharing',
            },
        ],
        'www.wixgateway.com': [
            {
                srcPath: '/wix-data/v1/items',
                destPath: '/v1/items',
            },
            {
                srcPath: '/wix-data/v1/bulk',
                destPath: '/v1/bulk',
            },
        ],
        '*.dev.wix-code.com': [
            {
                srcPath: '/_api/cloud-data/v2',
                destPath: '/v2',
            },
            {
                srcPath: '/_api/cloud-data/v1/external-database-connections',
                destPath: '/v1/external-database-connections',
            },
            {
                srcPath: '/data/v1/data-collection-sharing',
                destPath: '/v1/data-collection-sharing',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/**
 * Creates a new data collection.
 *
 * The request body must include an ID, details for at least 1 field, and a permissions object. If any of these are missing, the collection isn't created.
 */
export function createDataCollection(payload) {
    var _a = serializer(_createDataCollectionRequest, {
        _array: _array,
        _dataCollection: _dataCollection,
        _field: _field,
        _numberRange: _numberRange,
        _object: _object,
        _objectField: _objectField,
        _typeMetadata: _typeMetadata,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createDataCollectionResponse, {
        _array: _array,
        _dataCollection: _dataCollection,
        _field: _field,
        _numberRange: _numberRange,
        _object: _object,
        _objectField: _objectField,
        _typeMetadata: _typeMetadata,
    }).fromJSON;
    function __createDataCollection(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.data.v2.data_collection',
            method: 'POST',
            methodFqn: 'com.wixpress.cloud.data.api.collectionservice.DataCollectionService.CreateDataCollection',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixpressCloudDataApiCollectionserviceDataCollectionServiceUrl({ protoPath: '/v2/collections', data: serializedData, host: host }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __createDataCollection.fromReq = fromReq;
    __createDataCollection.__isAmbassador = true;
    return __createDataCollection;
}
/** Retrieves a data collection by ID. */
export function getDataCollection(payload) {
    var _a = serializer(_getDataCollectionRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getDataCollectionResponse, {
        _array: _array,
        _dataCollection: _dataCollection,
        _field: _field,
        _numberRange: _numberRange,
        _object: _object,
        _objectField: _objectField,
        _typeMetadata: _typeMetadata,
    }).fromJSON;
    function __getDataCollection(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.data.v2.data_collection',
            method: 'GET',
            methodFqn: 'com.wixpress.cloud.data.api.collectionservice.DataCollectionService.GetDataCollection',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixpressCloudDataApiCollectionserviceDataCollectionServiceUrl({
                protoPath: '/v2/collections/{dataCollectionId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getDataCollection.fromReq = fromReq;
    __getDataCollection.__isAmbassador = true;
    return __getDataCollection;
}
/**
 * Retrieves a list of all data collections associated with the site or project.
 *
 * By default, the list is ordered by ID in ascending order.
 */
export function listDataCollections(payload) {
    var _a = serializer(_listDataCollectionsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_listDataCollectionsResponse, {
        _array: _array,
        _dataCollection: _dataCollection,
        _field: _field,
        _numberRange: _numberRange,
        _object: _object,
        _objectField: _objectField,
        _typeMetadata: _typeMetadata,
    }).fromJSON;
    function __listDataCollections(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.data.v2.data_collection',
            method: 'GET',
            methodFqn: 'com.wixpress.cloud.data.api.collectionservice.DataCollectionService.ListDataCollections',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixpressCloudDataApiCollectionserviceDataCollectionServiceUrl({ protoPath: '/v2/collections', data: serializedData, host: host }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __listDataCollections.fromReq = fromReq;
    __listDataCollections.__isAmbassador = true;
    return __listDataCollections;
}
/**
 * Retrieves multiple data collections by ID.
 * Used in frontend databinding to load multiple specific collections at once. For internal use only.
 */
export function bulkGetDataCollections(payload) {
    var _a = serializer(_bulkGetDataCollectionsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkGetDataCollectionsResponse, {
        _array: _array,
        _dataCollection: _dataCollection,
        _field: _field,
        _numberRange: _numberRange,
        _object: _object,
        _objectField: _objectField,
        _typeMetadata: _typeMetadata,
    }).fromJSON;
    function __bulkGetDataCollections(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.data.v2.data_collection',
            method: 'POST',
            methodFqn: 'com.wixpress.cloud.data.api.collectionservice.DataCollectionService.BulkGetDataCollections',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixpressCloudDataApiCollectionserviceDataCollectionServiceUrl({ protoPath: '/v2/bulk/collections/get', data: serializedData, host: host }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkGetDataCollections.fromReq = fromReq;
    __bulkGetDataCollections.__isAmbassador = true;
    return __bulkGetDataCollections;
}
/**
 * Updates a data collection.
 *
 * A collection ID, revision number, permissions, and at least 1 field must be provided within the `collection` body parameter.
 * If a collection with that ID exists, and if its current `revision` number matches the one provided, it's updated.
 * Otherwise, the request fails.
 *
 * When a collection is updated, its `updatedDate` property is changed to the current date and its `revision` property is incremented.
 *
 * <blockquote class="important">
 * <strong>Important:</strong>
 * After a collection is updated, it only contains the properties included in the Update Data Collection request. If the existing collection
 * has properties with values and those properties aren't included in the updated collection details, their values are lost.<br/><br/>
 *
 * To update a single field, use the Update Data Collection Field method.
 * </blockquote>
 */
export function updateDataCollection(payload) {
    var _a = serializer(_updateDataCollectionRequest, {
        _array: _array,
        _dataCollection: _dataCollection,
        _field: _field,
        _numberRange: _numberRange,
        _object: _object,
        _objectField: _objectField,
        _typeMetadata: _typeMetadata,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateDataCollectionResponse, {
        _array: _array,
        _dataCollection: _dataCollection,
        _field: _field,
        _numberRange: _numberRange,
        _object: _object,
        _objectField: _objectField,
        _typeMetadata: _typeMetadata,
    }).fromJSON;
    function __updateDataCollection(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.data.v2.data_collection',
            method: 'PUT',
            methodFqn: 'com.wixpress.cloud.data.api.collectionservice.DataCollectionService.UpdateDataCollection',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixpressCloudDataApiCollectionserviceDataCollectionServiceUrl({ protoPath: '/v2/collections', data: serializedData, host: host }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateDataCollection.fromReq = fromReq;
    __updateDataCollection.__isAmbassador = true;
    return __updateDataCollection;
}
/**
 * Deletes a data collection.
 *
 * Before deleting a collection:
 * - Make sure the collection isn't connected to any site pages or elements.
 * - You can create a manual backup of a collections with the Backups API, in case you need to restore them later.
 * - You can also export a collection to a CSV file with the Data Movement Jobs API, if you want to save the data outside of Wix.
 *
 * > **Note:**
 * > Once a collection is deleted, it can only be restored for a limited amount of time.
 */
export function deleteDataCollection(payload) {
    var _a = serializer(_deleteDataCollectionRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_deleteDataCollectionResponse, {}).fromJSON;
    function __deleteDataCollection(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.data.v2.data_collection',
            method: 'DELETE',
            methodFqn: 'com.wixpress.cloud.data.api.collectionservice.DataCollectionService.DeleteDataCollection',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixpressCloudDataApiCollectionserviceDataCollectionServiceUrl({
                protoPath: '/v2/collections/{dataCollectionId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __deleteDataCollection.fromReq = fromReq;
    __deleteDataCollection.__isAmbassador = true;
    return __deleteDataCollection;
}
/**
 * Restores recently deleted collection.
 *
 * Fails with `WDE0025` if collection was deleted too long ago or has never existed.
 */
export function restoreDataCollection(payload) {
    var _a = serializer(_restoreDataCollectionRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_restoreDataCollectionResponse, {
        _array: _array,
        _dataCollection: _dataCollection,
        _field: _field,
        _numberRange: _numberRange,
        _object: _object,
        _objectField: _objectField,
        _typeMetadata: _typeMetadata,
    }).fromJSON;
    function __restoreDataCollection(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.data.v2.data_collection',
            method: 'POST',
            methodFqn: 'com.wixpress.cloud.data.api.collectionservice.DataCollectionService.RestoreDataCollection',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixpressCloudDataApiCollectionserviceDataCollectionServiceUrl({
                protoPath: '/v2/collections/restore/{dataCollectionId}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __restoreDataCollection.fromReq = fromReq;
    __restoreDataCollection.__isAmbassador = true;
    return __restoreDataCollection;
}
/** Patches (partial update) a data collection. */
export function patchDataCollection(payload) {
    var _a = serializer(_patchDataCollectionRequest, {
        _array: _array,
        _dataCollection: _dataCollection,
        _field: _field,
        _numberRange: _numberRange,
        _object: _object,
        _objectField: _objectField,
        _typeMetadata: _typeMetadata,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_patchDataCollectionResponse, {
        _array: _array,
        _dataCollection: _dataCollection,
        _field: _field,
        _numberRange: _numberRange,
        _object: _object,
        _objectField: _objectField,
        _typeMetadata: _typeMetadata,
    }).fromJSON;
    function __patchDataCollection(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.data.v2.data_collection',
            method: 'PATCH',
            methodFqn: 'com.wixpress.cloud.data.api.collectionservice.DataCollectionService.PatchDataCollection',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixpressCloudDataApiCollectionserviceDataCollectionServiceUrl({
                protoPath: '/v2/collections/{dataCollection.id}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __patchDataCollection.fromReq = fromReq;
    __patchDataCollection.__isAmbassador = true;
    return __patchDataCollection;
}
/** Adds a new field to the structure of a data collection. */
export function createDataCollectionField(payload) {
    var _a = serializer(_createDataCollectionFieldRequest, { _array: _array, _field: _field, _numberRange: _numberRange, _object: _object, _objectField: _objectField, _typeMetadata: _typeMetadata }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createDataCollectionFieldResponse, {
        _array: _array,
        _dataCollection: _dataCollection,
        _field: _field,
        _numberRange: _numberRange,
        _object: _object,
        _objectField: _objectField,
        _typeMetadata: _typeMetadata,
    }).fromJSON;
    function __createDataCollectionField(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.data.v2.data_collection',
            method: 'POST',
            methodFqn: 'com.wixpress.cloud.data.api.collectionservice.DataCollectionService.CreateDataCollectionField',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixpressCloudDataApiCollectionserviceDataCollectionServiceUrl({
                protoPath: '/v2/collections/create-field',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __createDataCollectionField.fromReq = fromReq;
    __createDataCollectionField.__isAmbassador = true;
    return __createDataCollectionField;
}
/** Updates a field in the structure of a data collection. */
export function updateDataCollectionField(payload) {
    var _a = serializer(_updateDataCollectionFieldRequest, { _array: _array, _field: _field, _numberRange: _numberRange, _object: _object, _objectField: _objectField, _typeMetadata: _typeMetadata }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateDataCollectionFieldResponse, {
        _array: _array,
        _dataCollection: _dataCollection,
        _field: _field,
        _numberRange: _numberRange,
        _object: _object,
        _objectField: _objectField,
        _typeMetadata: _typeMetadata,
    }).fromJSON;
    function __updateDataCollectionField(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.data.v2.data_collection',
            method: 'POST',
            methodFqn: 'com.wixpress.cloud.data.api.collectionservice.DataCollectionService.UpdateDataCollectionField',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixpressCloudDataApiCollectionserviceDataCollectionServiceUrl({
                protoPath: '/v2/collections/update-field',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateDataCollectionField.fromReq = fromReq;
    __updateDataCollectionField.__isAmbassador = true;
    return __updateDataCollectionField;
}
/**
 * Deletes a field from the structure of a data collection.
 *
 * When a field is deleted, all values associated with that field are also deleted
 * from all items in the collection.
 */
export function deleteDataCollectionField(payload) {
    var _a = serializer(_deleteDataCollectionFieldRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_deleteDataCollectionFieldResponse, {
        _array: _array,
        _dataCollection: _dataCollection,
        _field: _field,
        _numberRange: _numberRange,
        _object: _object,
        _objectField: _objectField,
        _typeMetadata: _typeMetadata,
    }).fromJSON;
    function __deleteDataCollectionField(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.data.v2.data_collection',
            method: 'POST',
            methodFqn: 'com.wixpress.cloud.data.api.collectionservice.DataCollectionService.DeleteDataCollectionField',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixpressCloudDataApiCollectionserviceDataCollectionServiceUrl({
                protoPath: '/v2/collections/delete-field',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __deleteDataCollectionField.fromReq = fromReq;
    __deleteDataCollectionField.__isAmbassador = true;
    return __deleteDataCollectionField;
}
/** Adds a plugin to a data collection. */
export function addDataCollectionPlugin(payload) {
    var _a = serializer(_addDataCollectionPluginRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_addDataCollectionPluginResponse, {
        _array: _array,
        _dataCollection: _dataCollection,
        _field: _field,
        _numberRange: _numberRange,
        _object: _object,
        _objectField: _objectField,
        _typeMetadata: _typeMetadata,
    }).fromJSON;
    function __addDataCollectionPlugin(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.data.v2.data_collection',
            method: 'POST',
            methodFqn: 'com.wixpress.cloud.data.api.collectionservice.DataCollectionService.AddDataCollectionPlugin',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixpressCloudDataApiCollectionserviceDataCollectionServiceUrl({ protoPath: '/v2/collections/add-plugin', data: serializedData, host: host }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __addDataCollectionPlugin.fromReq = fromReq;
    __addDataCollectionPlugin.__isAmbassador = true;
    return __addDataCollectionPlugin;
}
/** Deletes a plugin from a data collection. */
export function deleteDataCollectionPlugin(payload) {
    var _a = serializer(_deleteDataCollectionPluginRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_deleteDataCollectionPluginResponse, {
        _array: _array,
        _dataCollection: _dataCollection,
        _field: _field,
        _numberRange: _numberRange,
        _object: _object,
        _objectField: _objectField,
        _typeMetadata: _typeMetadata,
    }).fromJSON;
    function __deleteDataCollectionPlugin(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.data.v2.data_collection',
            method: 'POST',
            methodFqn: 'com.wixpress.cloud.data.api.collectionservice.DataCollectionService.DeleteDataCollectionPlugin',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixpressCloudDataApiCollectionserviceDataCollectionServiceUrl({
                protoPath: '/v2/collections/delete-plugin',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __deleteDataCollectionPlugin.fromReq = fromReq;
    __deleteDataCollectionPlugin.__isAmbassador = true;
    return __deleteDataCollectionPlugin;
}
/** Patches (partial update) a field in the structure of a data collection. */
export function patchDataCollectionField(payload) {
    var _a = serializer(_patchDataCollectionFieldRequest, { _array: _array, _field: _field, _numberRange: _numberRange, _object: _object, _objectField: _objectField, _typeMetadata: _typeMetadata }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_patchDataCollectionFieldResponse, {
        _array: _array,
        _dataCollection: _dataCollection,
        _field: _field,
        _numberRange: _numberRange,
        _object: _object,
        _objectField: _objectField,
        _typeMetadata: _typeMetadata,
    }).fromJSON;
    function __patchDataCollectionField(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.data.v2.data_collection',
            method: 'PATCH',
            methodFqn: 'com.wixpress.cloud.data.api.collectionservice.DataCollectionService.PatchDataCollectionField',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixpressCloudDataApiCollectionserviceDataCollectionServiceUrl({
                protoPath: '/v2/collections/{dataCollectionId}/fields/{field.key}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __patchDataCollectionField.fromReq = fromReq;
    __patchDataCollectionField.__isAmbassador = true;
    return __patchDataCollectionField;
}
//# sourceMappingURL=http.impl.js.map